import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { CompaniesRoutingModule } from './companies-routing.module';
import { CompaniesComponent } from './companies/companies.component';
import { CompaniesFilterComponent } from './companies/companies-filter/companies-filter.component';
import { CompaniesListComponent } from './companies/companies-list/companies-list.component';
import { CompaniesCreateComponent } from './companies-create/companies-create.component';
import { CompaniesCreateEditWidgetComponent } from './components/companies-create-edit-widget/companies-create-edit-widget.component';
import { CompaniesEditComponent } from './companies-edit/companies-edit.component';
import { CompaniesService } from './companies.service';

@NgModule({
  declarations: [CompaniesComponent, CompaniesFilterComponent, CompaniesListComponent, CompaniesCreateComponent, CompaniesCreateEditWidgetComponent, CompaniesEditComponent],
  imports: [CommonModule, CompaniesRoutingModule, FormsModule, ReactiveFormsModule, AppUiModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [CompaniesService],
})
export class CompaniesModule {}
